module.exports = __webpack_public_path__ + "img/banner-princiapal.ed4286da.png";